// extracted by mini-css-extract-plugin
module.exports = {"ModalContainer":"style_ModalContainer__DHgMb","ModalTitle":"style_ModalTitle__y2J_E","ModalContent":"style_ModalContent__1Id-a","ModalButton":"style_ModalButton__1j5h3"};